import React from 'react'
import { Illustration } from '@winnin/winnin_ui.components.illustration'
import { Title } from '@winnin/winnin_ui.components.title'
import './index.scss'

const GenericEmptyState = ({ title, description }) => {
  return (
    <div className="GenericEmptyState">
      <Illustration name="notEnoughData" width={444} height={197} />

      <div className="GenericEmptyState-content">
        <Title tag="h3" weight="semi">
          {title}
        </Title>
        <p>{description}</p>
      </div>
    </div>
  )
}

export default GenericEmptyState
